import * as React from "react";
const SvgFiRrExit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-exit_svg__a)">
      <path d="m22.83 9.171-3.88-3.879a1 1 0 0 0-1.414 1.414l3.88 3.88q.172.176.3.39c-.016 0-.028-.009-.043-.009L5.99 11a1 1 0 0 0 0 2l15.678-.032c.028 0 .051-.014.078-.016q-.132.256-.334.462l-3.879 3.88a1 1 0 1 0 1.414 1.413l3.88-3.879a4 4 0 0 0 0-5.656z" />
      <path d="M7 22H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h2a1 1 0 0 0 0-2H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h2a1 1 0 0 0 0-2" />
    </g>
    <defs>
      <clipPath id="fi-rr-exit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrExit;
